import {Component, isDevMode, OnInit} from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {BehaviorSubject, Observable} from "rxjs";
import {CentreOption} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {ChildService} from "../../../../components/child/child.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from 'firebase/compat/app';
import {ChartConfiguration, ChartEvent} from "chart.js";
import {map, switchMap} from "rxjs/operators";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {environment} from "../../../../../environments/environment";
import {endOfDay} from '../../../../utils/date-range-format.service';

@Component({
    selector: 'app-counselling-overview2',
    templateUrl: './counselling-overview2.component.html',
    styleUrls: ['./counselling-overview2.component.scss']
})
export class CounsellingOverview2Component implements OnInit {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    centres$: Observable<CentreOption[]>
    children$: Observable<FullChild[]>
    start: Date | undefined
    end: Date | undefined
    apexChartData1: number[] = []
    doughnutChartDatasets1?: ChartConfiguration<'pie'>['data']['datasets'];
    searchText: string = '';
    selectedChild: FullChild | undefined
    selectedCentre: string = 'All'
    mData: any[] = []
    showChart=false
    apexChartData: number[] = []
    private selectedCentreSubject = new BehaviorSubject<string>(this.selectedCentre);


    doughnutChartOptions: ChartConfiguration<'pie'>['options'] = {
        responsive: false,
        plugins: {
            legend: {
                display: true,
                position: 'top'
            },
            // @ts-ignore
            // Add dataLabels plugin configuration
            dataLabels: {
                display: true, // Enable data labels
                formatter: (value: number, context: ChartEvent) => {
                    // @ts-ignore
                    const label = context.dataset.label || ''; // Get dataset label
                    return `${label}: ${value}%`; // Format label with percentage
                },
                fontColor: 'black', // Adjust data label text color
                fontSize: 14, // Adjust data label font size
            }
        },
    };  // doughnutChartLabels: string[] = ['Difficulty in Coping up', 'Sometimes', 'Able to Cope up'];
    doughnutChartLabels: string[] = ['😠 Difficulty in coping', '😊 Able to Cope up', '😐 Sometimes'];
    constructor(private readonly mCentreService: CentreService, private readonly mChildService: ChildService,
                private readonly mFirestore: AngularFirestore,
                private readonly financialYearService: FinancialYearService) {
        this.centres$ = this.mCentreService.getAllCentresOptions().pipe(
          map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        )
      // Observable to load children based on selected center
      this.children$ = this.selectedCentreSubject.asObservable().pipe(
        switchMap(centreCode => this.getAllotedChildListByCenter(centreCode))
      );
        // this.children$ = this.mChildService.getAllotedChildListByCenter(this.selectedCentre)
    }

    ngOnInit(): void {
      // Pre-fill the date range with the current financial year (search still requires an explicit click)
      const fy = this.financialYearService.getCurrentFinancialYear();
      this.start = fy.startDate;
      this.end = fy.endDate;
      this.selectedCentreSubject.next(this.selectedCentre);
    }
  OnChildSelected(){
    this.searchText = ''
  }
  clearFields() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.selectedCentre = 'All';
    this.selectedChild = undefined;
    this.mData = []
  }
    search() {
        let myQuery: firebase.firestore.Query<any> = this.mFirestore.collection(this.env.counsellingFollowUp).ref
     myQuery=myQuery.orderBy('dateOfAssessment', 'desc')
        if (this.start && this.end) myQuery = myQuery.where('dateOfAssessment', '>=', this.start).where('dateOfAssessment', '<=', endOfDay(this.end))
        if (this.selectedCentre != 'All') myQuery = myQuery.where('centreCode', '==', this.selectedCentre)
        if (this.selectedChild) myQuery = myQuery.where('childCode', '==', this.selectedChild.childCode)
// if(this.start && this.end) myQuery= myQuery.where('dateOfAssessment','>=',this.start).where('dateOfAssessment','<=',endOfDay(this.end))
        myQuery.get().then(res => {
            let sessions = res.docs.map(x => {
                return {id: x.id, ...x.data()}
            })
            this.mData = sessions
            console.log('DATA', this.mData)
this.startChart()
        })
    }
  // Method to retrieve child data based on selected center
  private getAllotedChildListByCenter(centreCode: string): Observable<FullChild[]> {
    return this.mFirestore.collection(this.env.counsellingFollowUp, ref =>
      ref.where('centreCode', '==', centreCode)
    )
      .valueChanges()
      .pipe(
        map(data => {
          const uniqueChildren = new Map<string, any>();
          data.forEach((child: any) => {
            if (!uniqueChildren.has(child.childCode)) {
              uniqueChildren.set(child.childCode, {
                childCode: child.childCode,
                firstName: child.childName.split(' ')[0],
                lastName: child.childName.split(' ')[1] || ''
              });
            }
          });
          return Array.from(uniqueChildren.values());
        })
      );
  }

    centreSelected() {
      console.log('Centre selected:', this.selectedCentre);
      this.selectedCentreSubject.next(this.selectedCentre);
        // this.children$ = this.mChildService.getAllotedChildListByCenter(this.selectedCentre)
    }
    private startChart() {
        let totalYes = 0
        let totalNo = 0
        let totalSometimes = 0
        this.mData.forEach((it: any) => {
            totalYes += it.questions.filter((x: any) => x.ans == 'Yes').length;
            totalNo += it.questions.filter((x: any) => x.ans == 'No').length;
            totalSometimes += it.questions.filter((x: any) => x.ans == 'Sometimes').length;

        })
        // // Refactored startDischargeChart() function
        // const totalYes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Yes').length;
        // const totalNo = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'No').length;
        // const totalSometimes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Sometimes').length;

        const total = totalYes + totalNo + totalSometimes
        const totalYesPercentage = Number(((totalYes / total) * 100).toFixed(2))
        const totalNoPercentage = Number(((totalNo / total) * 100).toFixed(2))
        const totalSometimesPercentage = Number(((totalSometimes / total) * 100).toFixed(2))

        // this.mData = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];

        // this.mDischargeChartData = [totalYes, totalNo, totalSometimes];

        this.apexChartData1 = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
        this.doughnutChartDatasets1 = [
            {data: this.apexChartData1, label: 'Follow Up Assessment Graph', backgroundColor: ["#ed7d31", "#70ad47", "#FFC000"]},
        ];
        this.showChart = true
    }
}
